import cn from 'clsx';
import React from 'react';

export type LinkWithIconProps = {
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  openInNewTab?: boolean;
};

export const LinkWithIcon: React.FC<LinkWithIconProps> = ({
  href = '#',
  onClick,
  className,
  children,
  icon,
  iconPosition = 'right',
  openInNewTab = true
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <a
      href={href}
      className={cn('d-inline-flex align-items-center gap-1 text-primary text-decoration-none fw-semibold', className)}
      onClick={onClick ? handleClick : undefined}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
    >
      {iconPosition === 'left' && icon}
      {children}
      {iconPosition === 'right' && icon}
    </a>
  );
};
